import { LevelType, PositionType } from 'data/types';
import { getGridSpacesForLevel } from 'utils/grid';
import { footprintPolygonsForLevel } from 'utils/lineset-cross-floor-route';
import { computeHomePerimeter } from 'utils/lineset-geometry';
import { LinesetPerimetersByLevelType } from 'utils/lineset-level-perimeters-types';
import { toPathfindingSpaces } from 'utils/linesets';

export function linesetLevelPerimeters(
  structure: LevelType[],
  levelUniqueId: string | undefined
): PositionType[][] {
  const levelIndex = structure.findIndex(
    (level) => level.uniqueId === levelUniqueId
  );
  if (levelIndex < 0) {
    return [];
  }
  const spaces = toPathfindingSpaces(
    getGridSpacesForLevel(structure, levelIndex),
    structure
  );
  return computeHomePerimeter(
    spaces,
    footprintPolygonsForLevel(structure, levelIndex)
  );
}

export function linesetPerimetersByLevel(
  structure: LevelType[]
): LinesetPerimetersByLevelType {
  return new Map(
    structure.map((level) => [
      level.uniqueId,
      linesetLevelPerimeters(structure, level.uniqueId)
    ])
  );
}

export function perimetersForLevel(
  perimetersByLevel: LinesetPerimetersByLevelType,
  levelUniqueId: string | undefined
): PositionType[][] {
  return (levelUniqueId && perimetersByLevel.get(levelUniqueId)) || [];
}
